import React, { useEffect } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import "./CertificationErrorPopup.css";

const CertificationErrorPopup = ({
  open,
  onClose,
  errorTitle = "Error",
  errorMessage = "Something went wrong. Please try again.",
}) => {
  useEffect(() => {
    if (open) {
      // Optional: Add any side effects when modal opens
    }
  }, [open]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="certificationErrorPopup__modal"
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      style={{ zIndex: "1200" }}
    >
      <Box className="certificationErrorPopup__container">
        <div className="certificationErrorPopup__content">
          <div className="certificationErrorPopup__iconWrapper">
            <ErrorIcon className="certificationErrorPopup__icon" />
          </div>

          <Typography
            id="error-modal-title"
            className="certificationErrorPopup__title"
          >
            {errorTitle}
          </Typography>

          <Typography
            id="error-modal-description"
            className="certificationErrorPopup__description"
          >
            {errorMessage}
          </Typography>

          <Button
            variant="contained"
            onClick={handleClose}
            className="certificationErrorPopup__button"
            fullWidth
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default CertificationErrorPopup;
